
const state = {
  id: null,
  options: {},
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
